export const buildApiBases = (apiUrl) => {
	const trimmedBase = (apiUrl || '').trim().replace(/\/+$/, '');
	if (!trimmedBase) return [];

	const candidates = [trimmedBase];
	if (!/\/api$/i.test(trimmedBase)) {
		candidates.push(`${trimmedBase}/api`);
	} else {
		candidates.push(trimmedBase.replace(/\/api$/i, ''));
	}

	return [...new Set(candidates)];
};

export const requestWithApiFallback = async (apiUrl, requestFactory) => {
	const apiBases = buildApiBases(apiUrl);
	let lastError = null;

	for (const base of apiBases) {
		try {
			return await requestFactory(base);
		} catch (error) {
			const status = error?.response?.status;
			lastError = error;
			if (status !== 404) break;
		}
	}

	if (lastError) throw lastError;
	throw new Error('Missing API base URL');
};

export const encodePathSegment = (value) => encodeURIComponent(String(value ?? ''));
